import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';

declare var grecaptcha: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  loginFrm: loginData = {
    loading: false,
    data: {
      email: '',
      senha: '',
      grecaptcharesponse: ''
    }
  }

  constructor(public userService: UserService, private router: Router) { }

  ngOnInit(): void {
    if (typeof grecaptcha !== 'undefined') {
      if (Object.prototype.toString.call(grecaptcha.render) == '[object Function]') {
        grecaptcha.render('captcha_element', {
          'sitekey': environment.siteKeyCaptcha
        });
      }
    }
  }

  logar() {
    this.loginFrm.data.grecaptcharesponse = (<HTMLInputElement>document.getElementsByName('g-recaptcha-response')[0]!).value;
    this.loginFrm.loading = true;
    this.userService
      .auth(this.loginFrm.data)
      .subscribe(
        (res) => {
          localStorage.setItem('botway', JSON.stringify({ "token": res.token, "nome": res.nome, "master": res.master, "permissoes": res.permissoes, "escritorio_id": res.escritorio_id, "escritorio": res.escritorio }));
          this.router.navigateByUrl(this.userService.redirectUrl);
          this.userService.redirectUrl = null;
        },
        (err) => {
          if (err.status == 401) {
            grecaptcha.reset();
            Swal.fire({
              title: 'Erro',
              text: String(err.error.message),
              icon: 'error',
              heightAuto: false,
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                confirmButton: 'btn-swal'
              },
            });
          }
          if (err.status == 422) {
            let txt = '';
            Object.values(err.error.errors).forEach((value: any, index) => {
              for (let i = 0; i < Array(value).length; i++) {
                txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
              }
            });
            Swal.fire({
              title: 'Erro',
              html: txt,
              icon: 'error',
              heightAuto: false,
              allowOutsideClick: false,
              focusConfirm: false,
              customClass: {
                confirmButton: 'btn-swal'
              },
            });
          }
          this.loginFrm.loading = false;
        },
        () => (this.loginFrm.loading = false)
      );
  }

}

export interface loginData {
  loading: boolean;
  data: {
    email: string;
    senha: string;
    grecaptcharesponse: string;
  }
}
